// Shared guard for "fetch this org's X into a redux slice".
//
// Every one of those thunks was written the same way: load on success, toast on
// failure, and leave whatever was already in the slice alone. That is harmless
// when the slice belongs to the same org - it is just stale - but these slices
// change owner. Switch org, or have the fetch fail, and the page keeps rendering
// the previous tenant's data under the new tenant's name. Reports already fixed
// this one page at a time by clearing before the request; this makes the same
// treatment uniform, and adds the part that clearing alone does not cover.
//
// Two rules, and a slice needs both:
//
//   1. Clear before the request leaves, not when it returns. An empty slice
//      renders an empty page, which is the honest thing to show while loading
//      and the only safe thing to show if the request then fails.
//
//   2. Only the newest request may write. Clicking through orgs fires these
//      faster than they come back, so without a sequence the answer for an org
//      you have left can land after the one you are looking at and repaint it -
//      the same cross-tenant display, reached by a race instead of an error.
const latestBySlice = new Map();

// Claims the slice for this request and returns the predicate that says whether
// it is still the current one. Call it after every await, before dispatching.
export const claimOrgScopedRequest = (sliceKey) => {
  const token = (latestBySlice.get(sliceKey) || 0) + 1;
  latestBySlice.set(sliceKey, token);
  return () => latestBySlice.get(sliceKey) === token;
};
